/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function () {
  const _ = {};

  _.Nav = {
    elems: {
      shopifySection: $('.shopify-section'),
      wrapperFull: $('.wrapper--full'),
      headerLower: $('.header__lower'),
      body: $('.template-page'),
      mainContent: $('.main-content'),
      chineseMenu: $('.chinese-menu'),
      clMenu: $('.cl-menu'),
      dirtyMenu: $('.dirty-menu'),
      gold42Menu: $('.42-gold-menu'),
      chineseMenuTab: $('.chinese-menu .header__menu__inner-select-brand__tabs'),
      clMenuTab: $('.cl-menu .header__menu__inner-select-brand__tabs'),
      dirtyMenuTab: $('.dirty-menu .header__menu__inner-select-brand__tabs'),
      gold42MenuTab: $('.42-gold-menu .header__menu__inner-select-brand__tabs'),
      chineseMobile: $('.chinese-menu-mobile'),
      clMobile: $('.cl-menu-mobile'),
      dirtyMobile: $('.dirty-menu-mobile'),
      gold42Mobile: $('.42-gold-menu-mobile'),
      searchBar: $('.search__predictive__outer'),
      logoLink: $('.header__logo__link'),
      headerMenuInner: $(".header__menu__inner-default"),
      chineseMobile: $(".chinese-menu-mobile"),
      clMobile: $(".cl-menu-mobile"),
      dirtyMobile: $(".dirty-menu-mobile"),
      gold42Mobile: $(".42-gold-menu-mobile"),
      collection: $(".collection"),
    },
    init() {
      $("[data-brand]").mousedown(function () {
        const newBrand = $(this).data("brand");
        _.Util.saveToStorage("brand", newBrand);
      });

      _.Util.updateToStorage();
      this.loadBrandFromStorage();
    },
    loadBrandFromStorage() {
      const chosenBrand = _.Util.loadFromStorage("brand") || "chinese";
      if (chosenBrand === "chinese" || window.location.href == 'https://chineselaundry.com/') {
        this.elems.chineseMenuTab.css("display", "flex");
        this.elems.clMenu.css("display", "none");
        this.elems.dirtyMenu.css("display", "none");
        this.elems.gold42Menu.css("display", "none");
        this.elems.clMobile.css("display", "none");
        this.elems.dirtyMobile.css("display", "none");
        this.elems.gold42Mobile.css("display", "none");
        this.elems.searchBar.addClass('search__predictive__outer--chinese');
      } else if (chosenBrand === "cl" || window.location.href == 'https://chineselaundry.com/pages/cl-by-laundry') {
        this.elems.chineseMenu.css("display", "none");
        this.elems.clMenuTab.css("display", "flex");
        this.elems.dirtyMenu.css("display", "none");
        this.elems.gold42Menu.css("display", "none");
        this.elems.chineseMobile.css("display", "none");
        this.elems.dirtyMobile.css("display", "none");
        this.elems.gold42Mobile.css("display", "none");
        this.elems.wrapperFull.css("background", "#fffbf2");
        this.elems.headerLower.css("background", "#fffbf2");
        this.elems.shopifySection.css("background", "#fffbf2");
        this.elems.body.css("background", "#fffbf2");
        this.elems.mainContent.css("background", "#fffbf2");
        this.elems.searchBar.addClass('search__predictive__outer--cl');
        this.elems.collection.addClass("collection--cl");
      } else if (chosenBrand === "dirty" || window.location.href == 'https://chineselaundry.com/pages/dirty-laundry') {
        this.elems.chineseMenu.css("display", "none");
        this.elems.clMenu.css("display", "none");
        this.elems.dirtyMenuTab.css("display", "flex");
        this.elems.gold42Menu.css("display", "none");
        this.elems.clMobile.css("display", "none");
        this.elems.dirtyMobile.css("display", "none");
        this.elems.gold42Mobile.css("display", "none");
        this.elems.searchBar.addClass('search__predictive__outer--dirty');
      } else if (chosenBrand === "42-gold" || window.location.href == 'https://chineselaundry.com/pages/42-gold') {
        this.elems.chineseMenu.css("display", "none");
        this.elems.clMenu.css("display", "none");
        this.elems.dirtyMenu.css("display", "none");
        this.elems.gold42MenuTab.css("display", "flex");
        this.elems.clMobile.css("display", "none");
        this.elems.dirtyMobile.css("display", "none");
        this.elems.gold42Mobile.css("display", "none");
        this.elems.searchBar.addClass('search__predictive__outer--42-gold');
      }
    },
  }

  _.Util = {
    saveToStorage(key, value) {
      if (typeof value === "string") localStorage.setItem(key, value);
      else localStorage.setItem(key, JSON.stringify(value));
    },
    updateToStorage() {
      const chineseUrl = 'https://chineselaundry.com/';
      const clUrl = 'https://chineselaundry.com/pages/cl-by-laundry';
      const dirtyUrl = 'https://chineselaundry.com/pages/dirty-laundry';
      const gold42Url = 'https://chineselaundry.com/pages/42-gold';
      const tempUrl = window.location.href;

      tempUrl == chineseUrl ? localStorage.setItem('brand', 'chinese')
        : tempUrl == clUrl ? localStorage.setItem('brand', 'cl')
          : tempUrl == dirtyUrl ? localStorage.setItem('brand', 'dirty')
            : tempUrl == gold42Url ? localStorage.setItem('brand', '42-gold')
              : '';
    },
    loadFromStorage(key) {
      return localStorage.getItem(key);
    },
  };

  _.Nav.init();
  if ($('[data-section-type="product"]').length) {
    _.Nav.updateFromProduct();
  }
})();
